import { render, staticRenderFns } from "./setup-bsj-mileage-modal.vue?vue&type=template&id=08495344"
import script from "./setup-bsj-mileage-modal.vue?vue&type=script&lang=js"
export * from "./setup-bsj-mileage-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports